var render = function render(){var _vm=this,_c=_vm._self._c;return _c('EditTable',{attrs:{"items":_vm.notifications,"label":"UUDISED"},on:{"createEvent":_vm.createNotification,"updateEvent":_vm.updateNotification,"deleteEvent":_vm.deleteNotification}})
}
var staticRenderFns = []

export { render, staticRenderFns }